(function ($, Drupal) {
  Drupal.behaviors.svgColor = {
    attach: function (context, settings) {

      // Using snap.svg library ( http://snapsvg.io/ ) to modify displayed SVG images.
      $('.object-change-color').each(function() {
        var s = Snap(this);
        s.attr('fill', 'green');
      });

    }
  }
})(jQuery, Drupal);
